import React from 'react';
import '../../styles/header.css';
import Logo from '../Assets/iste_logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Nav, Navbar, Form, NavDropdown, Button } from 'react-bootstrap';

const Header = () => {
    return (
      <section className="header-whole">
        <Navbar bg="light" expand="lg">
          <Navbar.Brand href="/">
          <img
            src={Logo}
            alt="ISTE Logo"
            width="30"
            height="30"
            className="logo d-inline-block align-top"
          />{' '}
          <span className="heading-nav" href="/">INDIAN SOCEITY FOR TECHNICAL EDUCATION</span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className=" mr-auto">
              <Nav.Link className="text-nav" href="/">💒Home</Nav.Link>
              <Nav.Link className="text-nav" href="/aboutus">🔍About Us</Nav.Link>
              <NavDropdown className="text-nav-more" title="📥More" id="basic-nav-dropdown">
                <NavDropdown.Item className="text-nav-drop" href="/">Events</NavDropdown.Item>
                <NavDropdown.Item className="text-nav-drop" href="/team">Team</NavDropdown.Item>
                <NavDropdown.Item className="text-nav-drop" href="/contact">Contact Us</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item className="text-nav-drop" href="/termsandconditions">Terms and Conditions</NavDropdown.Item>
                <NavDropdown.Item className="text-nav-drop" href="/privacypolicy">Privacy Policy</NavDropdown.Item>
              </NavDropdown>
            </Nav>
            <Form className="social-links" inline>
              <Button className="btn-lg mt-2 mr-2 social-color" variant="outline-danger" href="/"><FontAwesomeIcon icon={["fab", "linkedin"]} /></Button>
              <Button className="btn-lg mt-2 mr-2 social-color" variant="outline-danger" href="/"><FontAwesomeIcon icon={["fab", "github"]} /></Button>
              <Button className="btn-lg mt-2 mr-2 social-color" variant="outline-danger" href="/"><FontAwesomeIcon icon={["fab", "instagram"]} /></Button>
              <Button className="btn-lg mt-2 mr-2 social-color" variant="outline-danger" href="/"><FontAwesomeIcon icon={["fab", "facebook"]} /></Button>
              <Button className="btn-lg mt-2 mr-2 social-color" variant="outline-danger" href="/"><FontAwesomeIcon icon={["fab", "discord"]} /></Button>
            </Form>
          </Navbar.Collapse>
        </Navbar>
      </section>
    );
};


export default Header;
